import React from "react";
import { prettyStatus, statusClass } from "./api";

const StatusPill = ({ value }: { value?: string }) => (
  <span
    className={`px-2 py-0.5 rounded-full text-[11px] font-medium whitespace-nowrap ${statusClass(
      value
    )}`}>
    {prettyStatus(value) || "\u2014"}
  </span>
);

export default StatusPill;
